
export function getBaseUrl() {

   //return 'http://localhost:44339/';
  return '//ai.cizhuangyuan.com/uc/';
}


